
import './App.css';
import { useEffect } from 'react';
import Footer from './Components/Elements/Footer';
import Navbar from './Components/Elements/Navbar';
import WhatsAppButton from './Components/Elements/WhatsAppButton';
import LandingPage from './Components/Pages/LandingPage';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import SWRYApage from './Components/Pages/SWRYApage';
import AboutUsPage from './Components/Pages/AboutUsPage';
import ContactPage from './Components/Pages/ContactPage';
import PrivacyNoticePage from './Components/Pages/PrivacyNoticePage';
import SolutionsRFID from './Components/Pages/SolutionsRFID';
import LevelsPage from './Components/Pages/LevelsPage';
import VisiontecLanding from './Components/Pages/VisiontecLanding';
import CatalogoPage from './Components/Pages/CatalogoPage';
import ProductDetailPage from './Components/Pages/ProductDetailPage';
import SoportePage from './Components/Pages/SoportePage';
import ScrollEffects from './Components/Elements/ScrollEffects';

function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
}

function App() {

  return (
    <div>
      <ScrollToTop/>
      <ScrollEffects/>
      <Navbar/>

      <Routes>
        <Route path="/" element={<LandingPage/>}/>
        <Route path="/solutions" element={<SolutionsRFID/>}/>
        <Route path="/swrya" element={<SWRYApage/>}/>
        <Route path="/aboutUs" element={<AboutUsPage/>}/>
        <Route path="/contact" element={<ContactPage/>}/>
        <Route path="/privacy" element={<PrivacyNoticePage/>}/>
        <Route path="/learnmore" element={<LevelsPage/>}/>
        <Route path="/consultoria" element={<VisiontecLanding/>}/>
        <Route path="/catalogo" element={<CatalogoPage/>}/>
        <Route path="/catalogo/:id" element={<ProductDetailPage/>}/>
        <Route path="/soporte" element={<SoportePage/>}/>
        <Route path="*" element={<Navigate to="/" replace/>}/>
      </Routes>

      <Footer/>
      <WhatsAppButton/>
    </div>
  );
}

export default App;
